import { Component, OnInit, Inject } from '@angular/core';
import { ErrorStateMatcher } from '@angular/material/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ConfirmComponent } from '../../../shared/dialogs/confirm/confirm.component';
import { AuthService } from '../../../services/auth.service';
import { SnackBarIconService } from '../../../shared/snack-bar-icon/snack-bar-icon.service';
import { KnowledgeService } from 'src/app/services/knowledge.service';
import { KnowledgeBase } from 'src/app/models/knowledge-base';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-knowledge-dialog',
  templateUrl: './knowledge-dialog.component.html',
  styleUrls: ['./knowledge-dialog.component.scss'],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
  ]
})

export class KnowledgeDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();
  public entityForm: FormGroup;
  public isEdit: boolean;

  public KnowledgeDataSource: MatTableDataSource<any>
  public current_knowledge: KnowledgeBase;

  constructor(
    private fb: FormBuilder,
    public _knowledgeService: KnowledgeService,
    public _authService: AuthService,
    private snackBar: SnackBarIconService,
    @Inject(MAT_DIALOG_DATA) public data: KnowledgeBase
  ) {
    this.current_knowledge = this.data
  }

  ngOnInit() {
    //this._adapter.setLocale('pt');
    // check is is insert or update
    this.isEdit = this.data.id != "0"
    // create user form
    this.entityForm = this.createForm()
    // populate the form
    this.setFormValues(this.current_knowledge, this.entityForm)

  }

  insert() {
    if (this.entityForm.valid) {
      this._knowledgeService.spinner = true;
      let entity: KnowledgeBase = this.createEntity(this.entityForm.value);

      this._knowledgeService.insert(entity)
        .then((result) => {
          this.data.id = result.id
          this.isEdit = true;
          this.entityForm.controls.id.setValue(result.id);
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("insert knowledge error: " + error)
          let msgError: string = this._knowledgeService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this._knowledgeService.spinner = false
        });
    }

  }

  update() {
    if (this.entityForm.valid) {
      this._knowledgeService.spinner = true;
      let entity: KnowledgeBase = this.createEntity(this.entityForm.value);
      this._knowledgeService.update(entity)
        .then(() => {
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("knowledge update error: " + JSON.stringify(error))
          let msgError: string = this._knowledgeService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this._knowledgeService.spinner = false
        });
    }
  }

  createEntity(data: any): KnowledgeBase {

    let entity = new KnowledgeBase()
    entity.id = data.id;
    entity.name = data.name;
    entity.html = data.html;

    return entity;
  }

  setFormValues(data, form) {
    form.controls.id.setValue(data.id);
    form.controls.name.setValue(data.name);
    form.controls.html.setValue(data.html);
  }

  createForm() {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [Validators.required]),
      html: new FormControl('')
    });
    return form
  }

}

